import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Select from "react-select";
import loginLogo from "./logo.png";
import useRequest from "../../hooks/useRequest";
import { upperCase } from "../../constant/api";

import { useParams } from "react-router-dom";
import Textshow from "./Textshow";

const StepTwo = ({
  nextStep,
  handleNextStep,
  setAllFormData,
  allStepsData,
}) => {
  const { userId } = useParams();
  const [loader, setLoader] = useState(false);
  const [modal, setModal] = useState(false);
  const [managerId, setManagerId] = useState(localStorage.getItem("ManagerId"));
  const { response: responseSaveStepTwo, request: requestSaveStepTwo } =
    useRequest();
  const { response: responseCategory, request: requestCategory } = useRequest();
  const { request, response } = useRequest();
  const { response: responseSubCategory, request: requestSubCategory } =
    useRequest();
  const [touchedError, setTouchedError] = useState(false);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryType, setCAtegoryType] = useState("");
  const createOutletFields = (count = 1) =>
    Array.from({ length: count }, () => ({
      outletName: "",
      posId: "",
      posName: "",
    }));
  const [outletDetails, setOutletDetails] = useState([]);

  useEffect(() => {
    if (response) {
      const outlets = response?.data?.totalOutlet ?? 1;
      setOutletDetails(createOutletFields(outlets));
    }
  }, [response]);

  const handleTotalOutletChange = (e) => {
    const totalOutlet = parseInt(e.target.value, 10) || 1;
    setOutletDetails(createOutletFields(totalOutlet));
    setValue("totalOutlet", totalOutlet);
  };

  const handleOutletFieldChange = (index, field, value) => {
    setOutletDetails((prev) =>
      prev.map((item, itemIndex) =>
        itemIndex === index ? { ...item, [field]: value } : item
      )
    );
  };

  const buildOutletPayload = () => {
    if (categoryType == "multiple") {
      return outletDetails.map((item) => ({
        outletName: (item?.outletName || "").trim(),
        posId: (item?.posId || "").trim(),
        posName: (item?.posName || "").trim(),
      }));
    }

    const standaloneOutlet = outletDetails?.[0] || {
      outletName: "",
      posId: "",
      posName: "",
    };

    return [
      {
        outletName: "",
        posId: (standaloneOutlet?.posId || "").trim(),
        posName: (standaloneOutlet?.posName || "").trim(),
      },
    ];
  };

  const renderOutletFields = (showOutletName = true) => {
    const fieldsToRender =
      categoryType == "multiple"
        ? outletDetails
        : outletDetails?.length
        ? outletDetails
        : createOutletFields(1);

    return (
      <div className={fieldsToRender?.length > 0 ? "form-fields mt-4" : ""}>
        {fieldsToRender?.map((outlet, index) => (
          <div
            key={index}
            className="mb-4 p-3"
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              backgroundColor: "#f8fafc",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                marginBottom: "16px",
                color: "#1f2937",
              }}
            >
              {showOutletName ? `Outlet ${index + 1}` : "POS Details"}
            </div>
            <Row>
              {showOutletName && (
                <Col md={6} lg={5}>
                  <label>
                    Name of the Restaurant {index + 1}{" "}
                    <span className="error">*</span>
                  </label>
                  <div className="input-group mt-2">
                    <input
                      type="text"
                      id={`vendorName${index}`}
                      name={`vendorName${index}`}
                      placeholder="Enter restaurant name"
                      className={`form-control ${
                        touchedError && !(outlet?.outletName || "").trim()
                          ? "is-invalid"
                          : ""
                      }`}
                      value={outlet?.outletName || ""}
                      onChange={(e) =>
                        handleOutletFieldChange(
                          index,
                          "outletName",
                          e.target.value
                        )
                      }
                      required
                    />
                    {touchedError && !(outlet?.outletName || "").trim() && (
                      <div className="invalid-feedback">
                        The outlet name field is required.
                      </div>
                    )}
                  </div>
                </Col>
              )}
              <Col md={showOutletName ? 6 : 6} lg={showOutletName ? 3 : 5}>
                <label>POS ID {showOutletName ? index + 1 : ""}</label>
                <div className="input-group mt-2">
                  <input
                    type="text"
                    id={`posId${index}`}
                    name={`posId${index}`}
                    placeholder="Enter POS ID"
                    className="form-control"
                    value={outlet?.posId || ""}
                    onChange={(e) =>
                      handleOutletFieldChange(index, "posId", e.target.value)
                    }
                  />
                </div>
              </Col>
              <Col md={showOutletName ? 12 : 6} lg={showOutletName ? 4 : 7}>
                <label>
                  POS Name {showOutletName ? index + 1 : ""}{" "}
                  <span className="error">*</span>
                </label>
                <div className="input-group mt-2">
                  <input
                    type="text"
                    id={`posName${index}`}
                    name={`posName${index}`}
                    placeholder="Enter POS name"
                    className={`form-control ${
                      touchedError && !(outlet?.posName || "").trim()
                        ? "is-invalid"
                        : ""
                    }`}
                    value={outlet?.posName || ""}
                    onChange={(e) =>
                      handleOutletFieldChange(index, "posName", e.target.value)
                    }
                    required
                  />
                  {touchedError && !(outlet?.posName || "").trim() && (
                    <div className="invalid-feedback">
                      The POS name field is required.
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        ))}
      </div>
    );
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    setValue,
  } = useForm();

  useEffect(() => {
    requestCategory("POST", "manageCategory/getCategorys", {
      type: "vendorCategory",
    });
    requestSubCategory("POST", "manageCategory/getCategorys", {
      type: "vendorSubCategory",
    });
  }, []);

  useEffect(() => {
    if (responseCategory) {
      if (
        responseCategory?.status == true ||
        responseCategory?.status == "success"
      ) {
        setCategories(
          responseCategory?.data?.length > 0 ? responseCategory?.data : []
        );
      }
    }
  }, [responseCategory]);

  useEffect(() => {
    if (responseSubCategory) {
      if (
        responseSubCategory?.status == true ||
        responseSubCategory?.status == "success"
      ) {
        setSubCategories(
          responseSubCategory?.data?.length > 0 ? responseSubCategory?.data : []
        );
      }
    }
  }, [responseSubCategory]);

  useEffect(() => {
    if (userId) {
      request("GET", `user/getRegisterDetail/${userId}`);
    }
  }, [userId]);

  const onSubmit = (data) => {
    let isValid = true;
    const outletPayload = buildOutletPayload();

    for (let index = 0; index < outletPayload.length; index++) {
      const outlet = outletPayload[index];
      if (
        (categoryType == "multiple" && !outlet?.outletName) ||
        !outlet?.posName
      ) {
        toast.error("Please fill all required outlet fields");
        isValid = false;
        break;
      }
    }

    if (!isValid) {
      setLoader(false);
      return;
    }

    var getVendorID = "";
    if (data?.vendorSubCategory) {
      getVendorID = data?.vendorSubCategory?.map((val, i) => {
        return val?.value;
      });
    }

    requestSaveStepTwo("POST", "admin/vendor/registerStepTwo", {
      ...data,
      vendorSubCategory: getVendorID,
      outletName: outletPayload,
      managerId: managerId,
    });

    setAllFormData((pre) => ({
      ...pre,
      ...data,
      vendorSubCategory: getVendorID,
      outletDetails: outletPayload,
      outletName: outletPayload,
      managerId: managerId,
    }));
  };

  useEffect(() => {
    if (responseSaveStepTwo) {
      if (
        responseSaveStepTwo?.status == "success" ||
        responseSaveStepTwo?.status == true
      ) {
        toast.success(responseSaveStepTwo.message);
        if (responseSaveStepTwo.vendorType === "single") {
          handleNextStep(3);
        } else {
          handleNextStep(4);
        }

        setAllFormData((pre) => ({
          ...pre,
          vendorType: responseSaveStepTwo?.vendorType,
          vendorId: responseSaveStepTwo?.vendorId,
          outletId: responseSaveStepTwo?.outletId,
        }));
      } else {
        toast.error(responseSaveStepTwo?.message);
        setLoader(false);
      }
    }
  }, [responseSaveStepTwo]);

  useEffect(() => {
    if (allStepsData) {
      setSelectedCategory(allStepsData?.vendorCategory ?? "");
      setValue("totalOutlet", allStepsData?.totalOutlet ?? "");
      setValue("vendorCategory", allStepsData?.vendorCategory ?? "");
      setValue("vendorName", allStepsData?.vendorName ?? "");
      setValue("vendorSubCategory", allStepsData?.vendorSubCategory ?? "");
      setValue("managerId", managerId ?? "");
      setCAtegoryType(allStepsData.vendorType);

      setValue("managerId", managerId ?? "");
      if (allStepsData?.outletDetails?.length > 0) {
        setOutletDetails(allStepsData.outletDetails);
      } else if (
        allStepsData?.outletName?.length > 0 ||
        allStepsData?.posId?.length > 0 ||
        allStepsData?.posName?.length > 0
      ) {
        const outletNameData = allStepsData.outletName?.length
          ? allStepsData.outletName
          : [""];
        setOutletDetails(
          outletNameData.map((item, index) => ({
            outletName:
              typeof item === "object" ? item?.outletName || "" : item || "",
            posId:
              typeof item === "object"
                ? item?.posId || ""
                : allStepsData?.posId?.[index] || "",
            posName:
              typeof item === "object"
                ? item?.posName || ""
                : allStepsData?.posName?.[index] || "",
          }))
        );
      } else if (allStepsData?.vendorType == "single") {
        setOutletDetails(createOutletFields(1));
      }
    }
  }, [allStepsData]);
  return (
    <div className="ms-content-wrapper ms-auth">
      <div className="regi-section">
        <Row>
          <Col md={12}>
            <div className="regi-form two-step">
              <form
                className="needs-validation"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
              >
                <h3>
                  Registration : Step <span>{nextStep} of 6</span>
                </h3>
                <p>Please enter information to continue</p>
                <div className="form-vendor-regi">
                  <div className="form-vendor">
                    <Row>
                      <Col md={12}>
                        <label htmlFor="vendorCategory">
                          Select Your Category<span className="error">*</span>
                        </label>
                        <div className="dropdown-group">
                          <select
                            id="vendorCategory"
                            name="vendorCategory"
                            className={`form-control ${
                              touchedError
                                ? errors.vendorCategory?.type === "required"
                                  ? "is-invalid"
                                  : "is-valid"
                                : ""
                            }`}
                            {...register("vendorCategory", {
                              required: true,
                            })}
                            onChange={(e) => {
                              if (e.target.value) {
                                setError("vendorCategory", "");
                              } else {
                                setError("vendorCategory", {
                                  type: "required",
                                });
                              }
                              setValue("vendorCategory", e.target.value);

                              const selected = categories.find(
                                (cat) => cat._id == e.target.value
                              );

                              if (selected?._id) {
                                setSelectedCategory(selected?._id);
                                setCAtegoryType(selected.vendorType);
                                setOutletDetails(createOutletFields(1));
                                setModal(true);
                              } else {
                                setSelectedCategory("");
                                setOutletDetails([]);
                              }
                              setValue("totalOutlet", "");
                              setValue("vendorSubCategory", "");
                            }}
                          >
                            <option value=""> Select Catgeory </option>

                            {categories.length > 0 ? (
                              categories.map((cat) => {
                                return (
                                  <option
                                    value={cat._id}
                                    selected={
                                      getValues("vendorCategory") == cat._id
                                        ? "selected"
                                        : ""
                                    }
                                  >
                                    {upperCase(cat.name)}
                                  </option>
                                );
                              })
                            ) : (
                              <option value={0}> Categories not found</option>
                            )}
                          </select>
                          {errors.vendorCategory?.type === "required" && (
                            <div className="invalid-select invalid-feedback">
                              The category field is required.
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div
                          style={{
                            marginTop: "20px",
                          }}
                        >
                          <label htmlFor="vendorName">
                            Name of the{" "}
                            {categoryType == "multiple"
                              ? "Hotel"
                              : "Restaurent"}
                            <span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="vendorName"
                              id="vendorName"
                              placeholder="Place Name"
                              className={`form-control ${
                                touchedError
                                  ? errors.vendorName
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("vendorName", {
                                required: true,
                              })}
                            />

                            {errors.vendorName?.type === "required" && (
                              <div className="invalid-feedback">
                                The name of Restaurent/Hotel field is required.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                      {categoryType == "multiple" ? (
                        <Col md={12}>
                          <div
                            style={{
                              marginTop: "20px",
                            }}
                          >
                            <label htmlFor="totalOutlet">
                              Number of outlets<span className="error">*</span>
                            </label>
                            {/* <div className="input-group">
                              <input
                                type="text"
                                name="totalOutlet"
                                id="totalOutlet"
                                placeholder="Number of outlets"
                                className={`form-control ${
                                  touchedError
                                    ? errors.totalOutlet
                                      ? "is-invalid"
                                      : "is-valid"
                                    : ""
                                }`}
                                {...register("totalOutlet", {
                                  required: true,
                                  pattern: /^[0-9]/gm,
                                })}
                              />

                              {errors.totalOutlet?.type === "required" && (
                                <div className="invalid-feedback">
                                  The number of outlets field is required.
                                </div>
                              )}

                              {errors.totalOutlet?.type === "pattern" && (
                                <div className="invalid-feedback">
                                  Please enter a valid number of outlets.
                                </div>
                              )}
                            </div> */}
                            <div className="input-group">
                              <select
                                id="numberSelect"
                                name="number"
                                placeholder="Number of outlets"
                                className={`form-control ${
                                  touchedError
                                    ? errors.totalOutlet
                                      ? "is-invalid"
                                      : "is-valid"
                                    : ""
                                }`}
                                {...register("totalOutlet", {
                                  required: true,
                                })}
                                onChange={(e) => {
                                  handleTotalOutletChange(e);
                                }}
                              >
                                <option value={""} disabled selected>
                                  --Select outlet number--
                                </option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="14">14</option>
                                <option value="15">15</option>
                              </select>

                              {errors.totalOutlet?.type === "required" && (
                                <div className="invalid-feedback">
                                  The number of outlets field is required.
                                </div>
                              )}

                              {errors.totalOutlet?.type === "pattern" && (
                                <div className="invalid-feedback">
                                  Please enter a valid number of outlets.
                                </div>
                              )}
                            </div>
                          </div>

                          {renderOutletFields(true)}
                        </Col>
                      ) : categoryType == "single" ? (
                        <Col
                          md={12}
                          style={{
                            marginBottom: "20px",
                          }}
                        >
                          <div>
                            <label htmlFor="vendorSubCategory">
                              Select Your Sub-Category
                              <span className="error">*</span>
                            </label>
                            <div className="dropdown-group">
                              <Select
                                isMulti
                                name="vendorSubCategory"
                                options={
                                  subCategories.length > 0 &&
                                  subCategories.map((c) => {
                                    return {
                                      value: c._id,
                                      label: upperCase(c.name),
                                    };
                                  })
                                }
                                {...register("vendorSubCategory", {
                                  required: true,
                                })}
                                defaultValue={getValues("vendorSubCategory")}
                                onChange={(action) => {
                                  if (action?.length > 0) {
                                    setError("vendorSubCategory", "");
                                    setValue("vendorSubCategory", action);
                                  } else {
                                    setError("vendorSubCategory", {
                                      type: "required",
                                    });
                                    setValue("vendorSubCategory", []);
                                  }
                                }}
                                className={`basic-multi-select ${
                                  touchedError
                                    ? errors.vendorSubCategory
                                      ? "is-invalid"
                                      : "is-valid"
                                    : ""
                                }`}
                                classNamePrefix="select"
                              />
                              {errors.vendorSubCategory?.type ===
                                "required" && (
                                <div className="invalid-select invalid-feedback">
                                  The sub category field is required.
                                </div>
                              )}
                            </div>
                          </div>
                          {renderOutletFields(false)}
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  </div>
                  {/* {formik.values.vendorCategory ===
                    "62b429d59d1d55495a9056a9" && (
                    <div className="">
                      <div>
                        <label htmlFor="validationCustom01">
                          Select Your Sub-Category<span className="error">*</span>
                        </label>
                        <Select
                          isMulti
                          name="vendorSubCategory"
                          value={formik.values.vendorSubCategory}
                          options={
                            vendorSubCategories.length > 0 &&
                            vendorSubCategories.map((c) => {
                              return { value: c._id, label: upperCase(c.name) };
                            })
                          }
                          onChange={(action) => {
                            formik.setFieldValue("vendorSubCategory", action);

                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                        <div>
                          {isError && (
                            <div className="error">
                              Vendor sub categories are required
                            </div>
                          )}
                        </div>

                      </div>
                    </div>
                  )} */}
                  {/* {(formik.values.vendorCategory ===
                    "62b429b69d1d55495a9056a5" ||
                    formik.values.vendorCategory ===
                      "62b429c79d1d55495a9056a7") && (
                    <div className="">
                      <div>
                        <label htmlFor="validationCustom02">
                          Number of outlets<span className="error">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            id="validationCustom02"
                            name="totalOutlet"
                            onChange={formik.handleChange}
                            value={formik.values.totalOutlet}
                            required
                          />
                          <div className="invalid-feedback">
                            Please provide a valid Number.
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      className="steps-btn float-left "
                      type="button"
                      onClick={() => handleNextStep(1)}
                    >
                      <i>&#8592;</i> Previous
                    </button>
                  </div>
                  <div className="col-md-6">
                    {loader ? (
                      <center>
                        <div
                          style={{
                            flex: 1,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Spinner
                            animation="border"
                            className="d-flex justify-content-center"
                          />
                        </div>
                      </center>
                    ) : (
                      <button
                        className="steps-btn"
                        type="submit"
                        onClick={() => setTouchedError(true)}
                      >
                        Next <i>&#8594;</i>
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </div>
      <Textshow
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        type={categoryType}
      />
    </div>
  );
};

export default StepTwo;
